import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector, shallowEqual } from 'react-redux';
import { useQuestionnaire } from '../hooks/useQuestionnaire';
import { LayoutSplashScreen } from '../../_metronic/layout';
import { isRoutePermissionAllowed } from '../permissions/routePermissions';

const ProtectedRoute = ({ component: Component, allowedRoles, ...rest }) => {
  const { questionnaireCompleted, isChecking } = useQuestionnaire();
  const user = useSelector(({ auth }) => auth.user, shallowEqual);
  const roleAllowed = isRoutePermissionAllowed(allowedRoles, user);

  if (isChecking) {
    return <LayoutSplashScreen />;
  }

  return (
    <Route
      {...rest}
      render={props =>
        questionnaireCompleted && roleAllowed ? (
          <Component {...props} />
        ) : (
          <Redirect to="/dashboard" />
        )
      }
    />
  );
};

export default ProtectedRoute;
